export enum PlayerType {
  IMAGE = 'image',
  VIDEO = 'video'
}
